import { kgToMt } from "@/lib/format"
import type { Contract } from "@/types/domain"

function csvEscape(value: unknown): string {
  if (value === null || value === undefined) return ""
  const str = typeof value === "string" ? value : String(value)
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

function rowsToCsv(rows: (string | number | null | undefined)[][]): string {
  return rows.map((cols) => cols.map(csvEscape).join(",")).join("\n")
}

function downloadCsv(filename: string, csv: string) {
  const blob = new Blob(["﻿", csv], { type: "text/csv;charset=utf-8;" })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

export function exportContractToCsv(contract: Contract) {
  const orderRows = (contract.Orders ?? []).map((order) => [
    order.orderNumber ?? "",
    order.groupId ?? "",
    kgToMt(order.agreedQuantity ?? 0),
    order.orderStatus ?? "",
    order.contractType ?? "",
    order.dateOfExportToPort ?? "",
    order.contractDurationStart ?? "",
    order.contractDurationEnd ?? "",
    (order.DeliveryForms ?? []).length,
  ])

  const lines: string[] = []
  lines.push(
    rowsToCsv([
      ["Contract"],
      ["contractNumber", contract.contractNumber ?? ""],
      ["contractDate", contract.contractDate ?? ""],
      ["contractType", contract.contractType ?? ""],
      ["clientName", contract.clientName ?? ""],
      ["productType", contract.productType ?? ""],
      ["cocoaGrade", contract.cocoaGrade ?? ""],
      ["quantityMt", contract.quantity ?? ""],
      ["origin", contract.origin ?? ""],
      ["currency", contract.currency ?? ""],
      ["basePrice", contract.basePrice ?? ""],
      ["incoterms", contract.incoterms ?? ""],
      ["portOfLoading", contract.portOfLoading ?? ""],
      ["destinationPort", contract.destinationPort ?? ""],
      ["pricingMechanism", contract.pricingMechanism ?? ""],
      ["status", contract.status ?? ""],
      ["notes", contract.notes ?? ""],
    ]),
  )
  lines.push("")
  lines.push(
    rowsToCsv([
      [
        "orderNumber",
        "groupId",
        "agreedQuantityMt",
        "orderStatus",
        "contractType",
        "dateOfExportToPort",
        "durationStart",
        "durationEnd",
        "deliveriesCount",
      ],
      ...orderRows,
    ]),
  )

  const stamp = new Date().toISOString().slice(0, 10)
  const safeNumber = (contract.contractNumber ?? `contract-${contract.id}`)
    .toString()
    .replace(/[^a-z0-9_-]+/gi, "-")
  downloadCsv(`${safeNumber}-${stamp}.csv`, lines.join("\n"))
}
